$(document).ready(function () {

  $("#size_chart_tabs_nav li").click(function () {
    if($(this).hasClass("active")){}
    else{
    $(this).closest("#size_chart_tabs_nav").find("li").removeClass("active");
    $(this).addClass("active");
    $(this)
      .closest("#size_chart_tabs_nav")
      .siblings("#size_chart_tabs-content")
      .find(".size_chart_tab-content")
      .hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
    }
  });

  $(".size-chart-link").click(function () {
    console.log("clicked");
    var get_pro_title = $('.product-form h1.title').text();
    $('.size_chart_tabs_pro_heading').text(get_pro_title);

    $(".cc-modal-window__foreground #size_chart_tabs_nav li").click(
      function () {
        $(this)
          .closest("#size_chart_tabs_nav")
          .find("li")
          .removeClass("active");
        $(this).addClass("active");
        $(this)
          .closest("#size_chart_tabs_nav")
          .siblings("#size_chart_tabs-content")
          .find(".size_chart_tab-content")
          .hide();

        var activeTab = $(this).find("a").attr("href");
        $(".cc-modal-window__foreground").find(activeTab).fadeIn();
        return false;
      }
    );
  });


  $(".quickbuy-toggle").click(function () {
    setTimeout(function () {
    $(".size-chart-link").click(function () {
    console.log("clicked");
    var get_pro_title = $('.product-form h1.title').text();
    $('.size_chart_tabs_pro_heading').text(get_pro_title);

    $(".cc-modal-window__foreground #size_chart_tabs_nav li").click(
      function () {
        $(this)
          .closest("#size_chart_tabs_nav")
          .find("li")
          .removeClass("active");
        $(this).addClass("active");
        $(this)
          .closest("#size_chart_tabs_nav")
          .siblings("#size_chart_tabs-content")
          .find(".size_chart_tab-content")
          .hide();

        var activeTab = $(this).find("a").attr("href");
        $(".cc-modal-window__foreground").find(activeTab).fadeIn();
        return false;
      }
    );
  });
      }, 2200);
  });
});
